document.addEventListener('DOMContentLoaded', () => {
    const menus = document.querySelectorAll('.block--hover-menu .hover-menu');

    function createHoverMenu() {
        return {
            menu: null,
            button: null,
            dropdown: null,
            isTouch: false,

            init: function(menuElement) {
                this.menu = menuElement;
                this.button = menuElement.querySelector('.hover-menu__button');
                this.dropdown = menuElement.querySelector('.hover-menu__dropdown');

                if (!this.button || !this.dropdown) return;

                // Detect touch device
                this.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

                this.setupListeners();
            },

            setupListeners: function() {
                // Touch device: tap to toggle
                if (this.isTouch) {
                    this.button.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.toggle();
                    });

                    // Close when clicking outside
                    document.addEventListener('click', (e) => {
                        if (!this.menu.contains(e.target)) {
                            this.close();
                        }
                    });
                }

                // Keyboard: Enter/Space to toggle, Escape to close
                this.button.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.toggle();
                    }
                    if (e.key === 'Escape') {
                        this.close();
                        this.button.focus();
                    }
                });

                // Close on Escape when focus is in dropdown
                this.dropdown.addEventListener('keydown', (e) => {
                    if (e.key === 'Escape') {
                        this.close();
                        this.button.focus();
                    }
                });

                // Handle focus leaving the menu
                this.menu.addEventListener('focusout', (e) => {
                    // Check if focus moved outside the menu
                    setTimeout(() => {
                        if (!this.menu.contains(document.activeElement)) {
                            this.close();
                        }
                    }, 0);
                });
            },

            toggle: function() {
                const isOpen = this.menu.classList.contains('is-open');
                if (isOpen) {
                    this.close();
                } else {
                    this.open();
                }
            },

            open: function() {
                this.menu.classList.add('is-open');
                this.button.setAttribute('aria-expanded', 'true');
                this.dropdown.setAttribute('aria-hidden', 'false');
            },

            close: function() {
                this.menu.classList.remove('is-open');
                this.button.setAttribute('aria-expanded', 'false');
                this.dropdown.setAttribute('aria-hidden', 'true');
            }
        };
    }

    // Initialize all hover menus
    menus.forEach(menu => {
        const instance = createHoverMenu();
        instance.init(menu);
    });
});
